import { render, staticRenderFns } from "./userLabes.vue?vue&type=template&id=60916955&scoped=true&"
import script from "./userLabes.vue?vue&type=script&lang=js&"
export * from "./userLabes.vue?vue&type=script&lang=js&"
import style0 from "./userLabes.vue?vue&type=style&index=0&id=60916955&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60916955",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\demoAdmin\\chuangyueBlockchaimAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60916955')) {
      api.createRecord('60916955', component.options)
    } else {
      api.reload('60916955', component.options)
    }
    module.hot.accept("./userLabes.vue?vue&type=template&id=60916955&scoped=true&", function () {
      api.rerender('60916955', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/users/userControl/components/userLabes.vue"
export default component.exports